import { render, staticRenderFns } from "./TileProdutor.vue?vue&type=template&id=60a2d98f&"
import script from "./TileProdutor.vue?vue&type=script&lang=js&"
export * from "./TileProdutor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports